import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="sold-items-options" 
export default class extends Controller {
  static targets = ["delayField"];

  connect() {
    this.initialValue = this.currentHandlingValue;
    
    this.radioButtonFields.forEach((radioButtonField) =>
      radioButtonField.addEventListener("change", () => this.toggle()),
    );

    this.toggle();
  }

  toggle(useInitialValue = false) {
    if (!this.hasDelayFieldTarget) return;
    
    // When called from form reset (useInitialValue = true), use the initial value
    // Otherwise use the currently checked value
    const value = useInitialValue ? this.initialValue : this.currentHandlingValue;

    if (value === "keep_sold_out") {
      this.delayFieldTarget.classList.add("hidden");
    } else {
      this.delayFieldTarget.classList.remove("hidden");
    }
  }

  get radioButtonFields() {
    return this.element.querySelectorAll('input[type="radio"]');
  }

  get currentHandlingValue() {
    let value = null;

    this.radioButtonFields.forEach((field) => {
      if (field.checked) {
        value = field.value;
      }
    });

    return value || this.initialValue || "keep_sold_out";
  }
}


